import authBg from "../../Assets/images/glp_banner.png"
import Login from "./Login";

const Auth = () => {
    return (
        <div className="w-full relative">
            <img src={authBg} alt="" />
            <div className="flex absolute top-1/2 left-0 w-full">
                <Login />
            </div>
        </div>
    )
}

export default Auth;